import { StateCreator } from 'zustand';

import { ImportEmployeesData, ImportEmployeesSlice } from './types';

const initialState: ImportEmployeesData = {
  companyId: '',
  companyName: '',
  payCalendarId: '',
  payCalendarName: '',
  bulkImportId: '',
  bulkImportStatus: undefined,
  leaveModalSource: undefined,
  fileType: undefined,
  hasNonSalariedWorkers: undefined,
  uploadedAETFile: undefined,
  uploadedEDFFile: undefined,
};

const importEmployeesSlice: StateCreator<ImportEmployeesSlice> = (set) => ({
  importEmployeesData: initialState,
  setImportEmployeesData(importEmployeesData) {
    set((state) => ({
      importEmployeesData: { ...state.importEmployeesData, ...importEmployeesData },
    }));
  },

  resetImportEmployeesData() {
    set({ importEmployeesData: initialState });
  },
});

export default importEmployeesSlice;
